import http from '../http-common';

class EmailQueueService {
  getAll(params = {}) {
    return http.get('/email-queue', { params });
  }

  get(id) {
    return http.get(`/email-queue/${id}`);
  }

  retry(id) {
    return http.post(`/email-queue/${id}/retry`);
  }

  cancel(id) {
    return http.post(`/email-queue/${id}/cancel`);
  }

  getStatistics() {
    return http.get('/email-queue/statistics');
  }

  cleanup(days = 30) {
    return http.post('/email-queue/cleanup', { days });
  }
}

export default new EmailQueueService();
